import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { PublishPosition } from './publish.interface';
import { PublishService } from './publish.service';

const service = new PublishService();

export interface PublishState {}

const PublishStore: Module<PublishState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async publish(context, payload: { positionId: number; publishData: PublishPosition }) {
         return await service.publish(payload.positionId, payload.publishData);
      },
   },
};

export default PublishStore;
